import { useMediaQuery } from '@/hooks/use-media-query';

export type UseDeviceProperties = {
  isMobile: boolean;
  isDesktop: boolean;
};

export function useDeviceProperties(): UseDeviceProperties {
  const isMobile = useMediaQuery('(max-width: 959px)');

  return {
    isMobile,
    isDesktop: !isMobile,
  };
}
